import post from './post.js';
import get from './get.js';

export default {
	get_list: ({ session }) => get('regions/list', { session }),
	get_by_id: ({ session, uid }) => get('regions/get', { session, uid }),
	update: ({ session, uid, data }) => post('regions/update', { session, uid, data }),
};
